<! --
/**
* SuiteCRM is a customer relationship management program developed by SuiteCRM Ltd.
* Copyright (C) 2021 SuiteCRM Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SUITECRM, SUITECRM DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<div class="list-view-settings w-100 d-flex justify-content-end">
    <ng-container *ngIf="(quickFilters.config$ | async) as vm">
        <div *ngIf="showQuickFilters && enableQuickFilters"
             class="d-flex align-items-baseline">
            <div class="text-nowrap text-muted fs-70 pl-1 mr-2">
                <scrm-label labelKey="LBL_QUICK_FILTERS"></scrm-label>
            </div>
            <div class="quick-filter-border pr-xxl-1 mr-xxl-1">
                <scrm-button-group *ngIf="quickFilters.config$" [config$]="quickFilters.config$" [klass]="'quick-filter-button'"></scrm-button-group>
            </div>
        </div>
    </ng-container>
    <div class="text-nowrap">
        <scrm-button-group *ngIf="config$" [config$]="config$" klass="d-flex align-items-center"></scrm-button-group>
    </div>
</div>
